import React from 'react';
import {observer} from "mobx-react";
import {UsefulLinksItemBox} from "./useful-links-item.box";
import {get} from 'lodash';
import {useServices} from "../../../../react-hooks/use-services.hook";
import {Image} from "../../../raw-components/image/image";
import {UsefulLinksItemSideTextBox} from "./useful-links-item-side-text.box";
import {MenuItemComponentProps} from "../../../../services/menu-items-common/menu-item-component-props.interface";
import {IAsset} from "../../../../themes/architecture/asset";


export const UsefulLinkItemComponent: React.FC<MenuItemComponentProps> = observer((props) => {
    const services = useServices();

    const onClickHandler = async () => {
        await props.menuItem.execute();
    }

    const getImageUrl = () => {
        if(!props.menuItem.icon) {
            return null;
        }

        switch (props.menuItem.iconSource) {
            case "themeImages":
                const imageAsset: IAsset = get(services.theme.currentTheme.images, props.menuItem.icon, null);
                return  imageAsset?.toString() ?? "";
            case "url":
                return props.menuItem.icon;
            default:
                return null;

        }
    }

    const imageURI = getImageUrl();


    const renderContent = () => {
        if(props.menuItem.imageOnlyRendering) {
            return (<Image src={imageURI} alt={props.menuItem.iconAltText ?? ''} />)
        } else {
            return (
                <>
                    {props.menuItem.text}
                    {props.menuItem.sideText && (<UsefulLinksItemSideTextBox >{props.menuItem.sideText}</UsefulLinksItemSideTextBox>)}
                </>
            )
        }
    }

    return (
        <UsefulLinksItemBox key={props.menuItem.key}
                            hideArrow={props.menuItem.imageOnlyRendering}
                            icon={props.menuItem.imageOnlyRendering ? null : imageURI}
                            className='cy-useful-links-item'
                            onClick={onClickHandler}>
            {renderContent()}
        </UsefulLinksItemBox>
    )

});